import { EBusinessDirector } from '../enums/business-director-type.enum';
import { IAppointmentType } from './appointment-type.interface';
import { IPersonalParticular } from './personal-particular.interface';
import { ISplitPart } from './split-part.interface';

export interface IBlankFormBd {
  appointmentType: IAppointmentType;
  appointmentTypeId: number;
  appTypeCode: string;
  id: number;
  data?: any;
  parties: ISplitPart[];
  receivedDirectPercent: number | null;
  receivedPercent: number;
  receivedValue?: number;
  salesperson: IPersonalParticular;
  salespersonId: number | null;
  splitMatrixId: number;
  tiers: ISplitPart[];
  totalAmount?: number;
  transactionId: number | null;
  type: EBusinessDirector;
  isDefault: boolean;
  attrs?: any;
}
